import { useCallback, useRef, useState } from "react";
import { isValidArray, scrollToTop } from "../../../Layout/Common/common";

import { ErrorItem } from "../ErrorItem";
import { SuccessMessageContainer } from "../../../Layout/Common/alert/SuccessMessageContainer";
import { useNavigate } from "react-router-dom";

export const QuickOrderCopyPast = ({ AddtoCart, onSuccessClose }) => {
  const [txtCopyPast, settxtCopyPast] = useState("");
  const [errorItem, setErrorItem] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const successMessageRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const navigate = useNavigate();

  const parseToJson = (text) => {
    const segments = text.split(/,|\n/);
    let final = segments
      .map((segment) => {
        const parts = segment.trim().split(" ");
        if (parts.length > 1) {
          parts[1] = parts[1].replace(/\D/g, "");
          return parts.join(" ");
        } else return segment;
      })
      .join("\n");

    return final;
  };
  const handleCallback = useCallback((errItem, addedItemCount) => {
    settxtCopyPast("");
    setIsAdding(false);
    if (addedItemCount > 0) {
      successMessageRef?.current?.showAlert("Item Added", `${addedItemCount} item(s) added to cart successfully.`);
    }
    setErrorItem(null);
    scrollToTop();
    navigate("/OrderDetails");
    onSuccessClose();
    // if (isValidArray(errItem)) {
    //   setErrorItem(errItem);
    // } else {
    //   setErrorItem(null);
    //   scrollToTop();
    //   navigate("/OrderDetails");
    //   onSuccessClose();
    // }
  }, []);

  const handleAddCart = () => {
    successMessageRef?.current?.hideAlert();
    if (txtCopyPast) {
      var data = txtCopyPast
        .split(/,|\n/)
        .filter((item) => item.trim())
        .map((item) => {
          const parts = item.trim().split(/\s+/);
          return {
            sku: parts[0],
            qty: parseInt(parts[1]),
          };
        });
      setIsAdding(true);
      AddtoCart(data, handleCallback, (progressValue, show) => {
        setProgress(progressValue);
        setShowProgress(show);
      });
    }
  };

  return (
    <div className="col-lg-12">
      <h3 className="quickOrder-title">Copy &amp; Paste Order</h3>
      <div className="pasteOrder">
        <form>
          <div className="mt-3">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="5"
              value={txtCopyPast}
              onChange={(e) => settxtCopyPast(parseToJson(e.target.value))}
              placeholder="Enter Code and then Qty"
            ></textarea>

            <div className="button-effect quickcart-btn mt-3">
              <button
                type="button"
                id="btnAddItem"
                className="btn theme-primary w-100"
                onClick={handleAddCart}
                disabled={!txtCopyPast || isAdding}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                {isAdding && showProgress ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: 8 }}
                    ></span>
                    Please Wait... {progress}%
                  </>
                ) : (
                  "Add Item"
                )}
              </button>
            </div>
          </div>
        </form>

        <SuccessMessageContainer ref={successMessageRef} autoClose={false} />
        {errorItem && <ErrorItem errItem={errorItem} />}
        <div className="paste-clarification mt-3">
          <p>
            Ex: ANT368 1 or ANT368, 1 <span>(Order Code Space/Comma Qty)</span>
          </p>
        </div>
        <div className="quickorder-instructions my-3">
          <h6>Instructions:</h6>
          <p>
            Copy and paste your order from your file into the space above, or type it manually with one item per line.
          </p>
          <p>
            The format that the order needs to be entered in is as follows: Code No. first, followed by the{" "}
            <span>required Qty, separated by a space or comma.</span>
          </p>
        </div>
      </div>
    </div>
  );
};
